module.exports = __webpack_public_path__ + "static/img/weiguanwang2.0fe7de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/weiguanwang2.png
// module id = SSQ5
// module chunks = 52